import { createSelector } from 'reselect'
import getFiltersProductSelect from 'modules/product/redux/selectors/get-filters'
import getPermalinkExpressCheckoutSelectUtil from 'containers/CartBottomBar/components/ExpressCheckoutButton/selectors/get-permalink/utils'
import hasInfoCartSelect from 'modules/cart/redux/selectors/has-info'
import getCurrentIdSidebarSelect from 'modules/sidebar/redux/selectors/get-current-id'

const getPermalinkExpressCheckoutSelect = createSelector(
  getFiltersProductSelect,
  hasInfoCartSelect,
  getCurrentIdSidebarSelect,
  (
    filters,
    hasCartInfo,
    // Self gifting: adding item to quick shop on step 2 redirects to step 1
    // @see {@link https://goairshop.atlassian.net/browse/AS-2313}
    // TODO omit when url is synced with redux store
    currentSidebarId
  ) => {
    return getPermalinkExpressCheckoutSelectUtil({
      filters,
      hasCartInfo,
      currentSidebarId
    })
  }
)

export default getPermalinkExpressCheckoutSelect
